import React, { useEffect, useState } from 'react';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import Spinner from '../../components/layout/Spinner';
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
  SIDEBAR_OPTIONS,
} from '../../shared/enums/clients_enum';
import SingleView from '../../components/common/SingleView';
import { useSingleClient } from '../../shared/hooks/UseClient';
import AllJobPostsComponent from '../../components/jobposts/AllJobPostsComponent';
import AllCandidatesComponent from '../../components/candidates/AllCandidatesComponent';
import AllInterviewComponent from '../../components/interviews/AllInterviewsComponent';
import { Link } from 'react-router-dom';
import moment from 'moment';
import FilterDateComponent from '../../components/common/FilterDateComponent';
import BillSection from './BillSection';
import api from '../../domain/api';
const ViewClient = ({ match }) => {
  const [data] = useSingleClient(match.params.id);
  const { loading, client } = data;
  const [csvFile, setCsvFile] = useState(null);
  const handleBulkImport = async (e) => {
    console.log('csvFile', csvFile);
    const values = {};

    values.client_name = match.params.id;

    const newForm = new FormData();

    newForm.append(`values`, JSON.stringify(values));

    newForm.append(`csv_file`, csvFile, csvFile.name);
    // const dataToSend = await convertToFormData({ values, featuredImage });
    // const { data } = await api.put(`/jobposts/${id}`, formData);
    // window.location.reload();
    try {
      const { data } = await api.post(`/candidates/upload-csv`, newForm);
      console.log('Data', data);
      // Show Success alert message
      alert('CSV uploaded successfully!');
      window.location.reload();
    } catch (error) {
      console.log('Error uploading CSV:', error);
    }
  };

  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink='View'
        />
        <FilterDateComponent link={`/clients/${match.params.id}/view`} />
        {/* <FilterDateComponent /> */}
        {!loading ? (
          client && (
            <>
              <SingleView
                data={client}
                inputFields={inputFields}
                label={PAGE_SINGLE_TITLE}
                link={LINK_URL}
                id={client._id}
                SIDEBAR_OPTIONS={SIDEBAR_OPTIONS}
              >
                <div className='col-md-3'>
                  <div className='card'>
                    <div className='card-header'>
                      <div className='card-title'>Import Candidates</div>
                    </div>
                    <div className='card-body'>
                      <div>
                        <a
                          href='/sample-candidate-import.csv'
                          target='_blank'
                          rel='noopener noreferrer'
                          className='btn btn-secondary btn-sm mb-2'
                        >
                          <i className='fa fa-download'></i> Download Sample
                        </a>
                      </div>
                      <div className='form-group'>
                        <label htmlFor='csvFile'>Upload CSV</label>
                        <input
                          type='file'
                          className='form-control'
                          accept='.csv'
                          id='csvFile'
                          onChange={(e) => {
                            setCsvFile(e.target.files[0]);
                          }}
                        />
                      </div>
                      <button
                        className='btn btn-primary mt-2'
                        onClick={handleBulkImport}
                      >
                        Upload
                      </button>
                    </div>
                  </div>
                </div>
              </SingleView>

              <BillSection client={match.params.id} />

              <AllJobPostsComponent
                label={'client_name'}
                value={match.params.id}
              />
              <AllCandidatesComponent
                label={'client_name'}
                value={match.params.id}
              />
              <AllInterviewComponent label={'client'} value={match.params.id} />
            </>
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewClient;
